var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-list',{attrs:{"v-model":_vm.loading,"finished":_vm.finished,"finished-text":_vm.text},on:{"load":_vm.onload}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('cell-order',{attrs:{"info":item}})],1)}),0),_vm._v(" "),(_vm.list.length==0 && _vm.finished)?_c('none'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc1faf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderItem.vue
// module id = null
// module chunks = 